import React from 'react';

import Icon from '@components/icon/Icon.tsx';

import I from '../types.ts';

const renderInstruction: I['renderInstruction'] = function () {
    const { device } = this.props;

    return (
        <div className="publicExecutorsHeader__instruction _row">
            <div className="publicExecutorsHeader__instructionItemsWrapper">
                <div className="publicExecutorsHeader__instructionItems _row">
                    <div className="publicExecutorsHeader__instructionItem">
                        <div className="publicExecutorsHeader__instructionStep _col">
                            <div className="publicExecutorsHeader__instructionStepTitle">
                                Регистрируйтесь на&nbsp;нашем сайте
                            </div>
                            <div className="publicExecutorsHeader__instructionStepDescription">
                                Это быстро
                                <br />
                                и&nbsp;бесплатно
                            </div>
                            <a
                                href={this.joinLink}
                                target="_blank"
                                className="publicExecutorsHeader__instructionStepLink"
                                rel="noreferrer"
                            >
                                Регистрация
                                <i className="publicExecutorsHeader__instructionStepLinkIcon">
                                    <Icon name="arrow-next-2" />
                                </i>
                            </a>
                        </div>
                    </div>
                    <div className="publicExecutorsHeader__instructionItem">
                        <div className="publicExecutorsHeader__instructionStep _col">
                            <div className="publicExecutorsHeader__instructionStepTitle">
                                Получите статус Самозанятого
                            </div>
                            <div className="publicExecutorsHeader__instructionStepDescription">
                                Скачайте и&nbsp;зарегистрируйтесь в&nbsp;приложении «Мой&nbsp;налог»
                            </div>
                            <a
                                href="https://npd.nalog.ru/app/"
                                target="_blank"
                                className="publicExecutorsHeader__instructionStepLink"
                                rel="noreferrer"
                            >
                                «Мой налог»
                                <i className="publicExecutorsHeader__instructionStepLinkIcon">
                                    <Icon name="arrow-next-2" />
                                </i>
                            </a>
                        </div>
                    </div>
                    <div className="publicExecutorsHeader__instructionItem">
                        <div className="publicExecutorsHeader__instructionStep _col">
                            <div className="publicExecutorsHeader__instructionStepTitle">
                                Подберите подходящую вакансию
                            </div>
                            <div className="publicExecutorsHeader__instructionStepDescription">
                                Или обратитесь к&nbsp;менеджеру
                            </div>
                        </div>
                    </div>
                    <div className="publicExecutorsHeader__instructionItem">
                        <div className="publicExecutorsHeader__instructionStep _col">
                            <div className="publicExecutorsHeader__instructionStepTitle">
                                Заключите договор
                            </div>
                            <div className="publicExecutorsHeader__instructionStepDescription">
                                И дождитесь подтверждения от&nbsp;заказчика
                            </div>
                        </div>
                    </div>
                    <div className="publicExecutorsHeader__instructionItem">
                        <div className="publicExecutorsHeader__instructionStep _col">
                            <div className="publicExecutorsHeader__instructionStepTitle">
                                Выполняйте задания
                            </div>
                            <div className="publicExecutorsHeader__instructionStepDescription">
                                И получайте вознаграждение
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="publicExecutorsHeader__instructionItem _info">
                <div className="publicExecutorsHeader__instructionTitle">
                    Как заработать первые деньги?
                </div>
                <p className="publicExecutorsHeader__instructionDescription">
                    {device === 'mobile' ? (
                        <>
                            Всего 5 шагов —<br />
                            листайте вправо
                        </>
                    ) : (
                        <>Всего 5 шагов</>
                    )}
                </p>
            </div>
        </div>
    );
};

export default renderInstruction;
